import Popover from './popover';

function popover(props) {
  return new Popover(props);
}

export default popover;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/popover/index.js
// module id = 560
// module chunks = 9